// extracted by mini-css-extract-plugin
export default {"generateIdButtonWrapper":"LocalmachineRequests_generateIdButtonWrapper__I9G04","tableHeader":"LocalmachineRequests_tableHeader__TqBWq"};